









































import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class DeleteSurveyPopup extends Vue {
  @Prop() popupId!: string;
  @Prop() coupon!: any;
  @Prop() brandId!: number

  deleteSurvey () {
    let popupCloseButton: HTMLElement = this.$refs.popupCloseButton as HTMLElement
    this.$store.dispatch('deleteCoupon', { brandId: this.brandId, couponId: this.coupon.id }).then(() => {
      this.$emit('deleted')
      popupCloseButton.click()
      this.$notify({ type: 'success', text: 'Coupon has been deleted successfully!' })
    }, () => popupCloseButton.click())
  }
}
